import React from "react";
import "./Breadcrumb.css";

export interface Item {
  disabled:boolean,
  title:string,
  to:string,
};

type Props = {
  style?: React.CSSProperties;
  items: Item[];
};

export default function Breadcrumb({ items, style = {} }: Props) {
  let result = [];
  for (let i = 0; i < items.length; i++) {
    let item = items[i];
    result.push(
      <svg
        style={{
          margin: "0px 10px 0px 10px",
        }}
        key={"arrow" + i}
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.3999 8L0.599902 15.7942L0.599903 0.205771L11.3999 8Z" fill="white" />
      </svg>
    );
    // if (item.disabled) {
      result.push(
        <a
          key={"link" + i}
          style={{
            marginRight: 14,
          }}
          href="#"
        >
          {item.title}
        </a>
      );
    // } else {
    //   result.push(
    //     <NavLink
    //       key={"link" + i}
    //       to={item.to}
    //       style={{
    //         marginRight: 14,
    //       }}
    //     >
    //       {item.title}
    //     </NavLink>
    //   );
    // }
  }

  return (
    <div
      className="header-breadcrumb"
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {result}
    </div>
  );
}
